import { render, staticRenderFns } from "./PlanoDeContas.vue?vue&type=template&id=b37f5456&scoped=true"
import script from "./PlanoDeContas.vue?vue&type=script&lang=js"
export * from "./PlanoDeContas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37f5456",
  null
  
)

export default component.exports